import React from "react";
import { LANG } from "../../../constants";
import Input from "../../form/Components/Fields/Input";
import Radio from "../../form/Components/Fields/Radio";
import Checkbox from "../../form/Components/Fields/Checkbox";
import Select from "../../form/Components/Fields/Select";
import Toggle from "../../form/Components/Fields/Toggle";
import Textarea from "../../form/Components/Fields/Textarea";
import Rating from "../../form/Components/Fields/Rating";
import Heading from "../../form/Components/Fields/Heading";
import Separator from "../../form/Components/Fields/Separator";
import * as moment from "moment";
// import UploadFile from "./UploadFile";

class SurveyView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(event) {
    event.preventDefault();

    let formGroup = document.getElementsByClassName("form-group");

    let questions = [];

    for (let k = 0; k < formGroup.length; k++) {
      if (formGroup[k].childNodes[0].childNodes[0].localName === "label") {
        questions.push(formGroup[k].childNodes[0].childNodes[0].innerText);
      }
    }

    let dataToSubmit = {
      id: this.props.data.id,
      formData: this.props.formData,
      timestamp: moment().valueOf(),
      version: this.props.data.version,
      dataObject: {},
    };

    var element = document.getElementsByTagName("input");

    var txtArea = document.getElementsByTagName("textarea");

    var selectType = document.getElementsByTagName("select");

    let ratingField = document.getElementsByClassName("ratingField");

    let tempRatingArr = Array.from(ratingField);

    let tempArrayCB = [];
    let ratingCountsArr = [];

    if (ratingField) {
      tempRatingArr.map((i, j) => {
        ratingCountsArr.push(0);
        Array.from(i.childNodes).map((m, n) => {
          if (m.classList.contains("checked")) {
            ratingCountsArr[j]++;
          }
          return null;
        });
        return null;
      });
    }

    if (ratingField) {
      ratingCountsArr.map((i, j) => {
        if (ratingField[j].parentElement.childNodes[0].localName === "label") {
          dataToSubmit.dataObject[
            ratingField[j].parentElement.childNodes[0].innerText
          ] = i;
        }
        return null;
      });
    }

    for (var i = 0; i < element.length; i++) {
      if (
        element[i].type === "text" ||
        element[i].type === "number" ||
        element[i].type === "email"
      ) {
        dataToSubmit.dataObject[element[i].previousSibling.innerText] =
          element[i].value;
      }

      if (
        element[i].checked &&
        element[i].type !== "text" &&
        element[i].type !== "checkbox" &&
        element[i].type === "radio" &&
        element[i].type !== "date"
      ) {
        dataToSubmit.dataObject[
          element[
            i
          ].parentElement.parentElement.parentElement.parentElement.childNodes[0].innerText
        ] = element[i].value;
      }

      if (element[i].type === "date") {
        if (element[i].parentElement.childNodes[0].localName === "label") {
          dataToSubmit.dataObject[
            element[i].parentElement.childNodes[0].innerText
          ] = element[i].value;
        }
      }

      if (element[i].checked && element[i].type === "checkbox") {
        if (element[i].parentElement.classList.value === "switch") {
          if (element[i].checked) {
            dataToSubmit.dataObject[
              element[i].parentElement.parentElement.childNodes[0].innerText
            ] = true;
          } else {
            dataToSubmit.dataObject[
              element[i].parentElement.parentElement.childNodes[0].innerText
            ] = false;
          }
        }
      }

      if (element[i].checked && element[i].type === "checkbox") {
        if (
          element[i].parentElement.parentElement.parentElement.parentElement
            .childNodes[0].childNodes[0].localName === "label"
        ) {
          tempArrayCB.push({
            [element[i].parentElement.parentElement.parentElement.parentElement
              .childNodes[0].childNodes[0].innerText]: element[i].value,
          });

          let keys;
          let values = [];
          tempArrayCB.map((h, g) => {
            keys = Object.keys(h);
            values.push(Object.values(h));
            return null;
          });

          let tempValues = [];
          let refinedValues = [];

          tempValues.push(values);

          tempValues[0].map((i, j) => {
            refinedValues.push(i[0]);
            return null;
          });

          dataToSubmit.dataObject[keys] = refinedValues;
        }
      }
    }

    for (var k = 0; k < txtArea.length; k++) {
      dataToSubmit.dataObject[
        txtArea[k].parentElement.childNodes[0].innerText
      ] = txtArea[k].value;
    }

    if (selectType.length) {
      for (var option of selectType) {
        // console.log(option.parentElement.childNodes[0].innerText);
        // console.log(option.value === 'Select from the dropdown' ? '': option.value);
        dataToSubmit.dataObject[
          option.parentElement.childNodes[0].innerText
        ] = option.value === 'Select from the dropdown' ? '' : option.value;

      }
    }


    // if (selectType[0]) {
    //   dataToSubmit.dataObject[
    //     selectType[0].parentElement.childNodes[0].innerText
    //   ] = selectType[0].value;
    // }

    this.props.sendData(dataToSubmit);
    // console.log(dataToSubmit);
  }

  render() {
    // console.log(this.props.infoObject);
    return (
      <div className="col-sm-12 col-md-10 col-lg-6 dashboardBG vertical-center-survey-1">
        <div className="row pr-4 mt-4">
          <div className="col-12">
            <center>
              <h5 className="ml-3 mb-4 custom-headin-temp">
                {this.props.data.title}
              </h5>
            </center>
            {/* <h6>Upload File</h6>
            <UploadFile />
            <hr />
            <center>
              <h6>OR</h6>
            </center>
            <hr />
            <h6>Fill Form</h6> */}
            <div className="">
              <form
                autoComplete="off"
                className="pb-5"
                onSubmit={this.submitForm}
              >
                {this.props.data.fields &&
                  this.props.data.fields.map((field, index) => {
                    switch (field.fieldType) {
                      case LANG.SEPARATOR:
                        return <Separator key={index} />;
                      case LANG.HEADING:
                        return <Heading key={index} field={field} />;
                      default:
                        switch (LANG.FIELD_TYPES[field.fieldType]) {
                          case LANG.FIELD_TYPES.text:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Input key={index} field={field} />
                              </div>
                            );
                          case LANG.FIELD_TYPES.numeric:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Input key={index} field={field} />
                              </div>
                            );
                          case LANG.FIELD_TYPES.date:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Input key={index} field={field} />
                              </div>
                            );
                          case LANG.FIELD_TYPES.email:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Input key={index} field={field} />
                              </div>
                            );
                          case LANG.FIELD_TYPES.dropdown:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Select key={index} field={field} />
                              </div>
                            );
                          case LANG.FIELD_TYPES.radio:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Radio key={index} field={field} />
                              </div>
                            );
                          case LANG.FIELD_TYPES.checkbox:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Checkbox key={index} field={field} />
                              </div>
                            );
                          case LANG.FIELD_TYPES.boolean:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Toggle key={index} field={field} />
                              </div>
                            );
                          case LANG.FIELD_TYPES.textarea:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Textarea key={index} field={field} />
                              </div>
                            );
                          case LANG.FIELD_TYPES.rating:
                            return (
                              <div
                                className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <Rating key={index} field={field} />
                              </div>
                            );
                          // case LANG.FIELD_TYPES.file:
                          //   return (
                          //     <div
                          //       className="survey-style-1 mt-3 pb-4 pt-4"
                          //       key={index}
                          //     >
                          //       <UploadFile key={index} field={field} />
                          //     </div>
                          //   );
                          default:
                            return (
                              <div
                                // className="survey-style-1 mt-3 pt-4"
                                key={index}
                              >
                                <div key={index}></div>
                              </div>
                            );
                        }
                    }
                  })}
                {this.props.data && (
                  <center className="mt-5">
                    <button
                      type="submit"
                      id="submit"
                      className="btn submitBtn action-btn"
                    >
                      Submit
                    </button>
                  </center>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SurveyView;
